import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { ROUTES } from 'utils/utils';
import { Row, Col, Icon, Alert, Card, Input, Divider, Button, Form } from 'antd';

export default class FsdoInformationVerification extends Component {
    state = { date: '', dateFormProps: {} }
    constructor(props) { super(props); }

    handleDate = (d, p) => this.setState({...this.state, date: d, dateFormProps: p.formProps || {} });
    handleDateFormProps = p => this.setState({...this.state, dateFormProps: p });

    isDisabled(date, returnResultObj) {
        returnResultObj = !!returnResultObj;
        let result = { disabled: null, formProps: {} };

        if(date.length === 0) result.disabled = true;
        else {
            let
            validDate = true,
            dateSections = date.split('-');

            var isFormatValid = moment( date.trim(), "MM-DD-YYYY", true ).isValid();

            var today = moment( date.trim(), "MM-DD-YYYY", true ).format( "MM-DD-YYYY" );
            var isToday = (today === moment().format( "MM-DD-YYYY" ) ||
                              today === moment().add(1, 'd').format( "MM-DD-YYYY" ) ||
                              today === moment().subtract(1, 'd').format( "MM-DD-YYYY" ))   ;

            if(dateSections.length === 3) {
                dateSections = dateSections.map(s => parseInt(s));

                for(let i in dateSections) {
                    let s = dateSections[i];
                    if(isNaN(s)) {
                        result.disabled = true;
                        result.formProps = {
                            validateStatus: 'warning',
                            help: 'Invalid date format.'
                        };
                        break;
                    }
                }

                if(result.disabled == null) {
                    if ( isFormatValid && isToday ) {
                        result.disabled = false;
                        result.formProps = {
                            validateStatus: 'success',
                            help: ''
                        };
                    }
                    else {
                        result.disabled = true;
                        result.formProps = {
                            validateStatus: 'error',
                            help: 'Invalid date.'
                        };
                    }
                }
            } else {
                result.disabled = true;
                result.formProps = {
                    validateStatus: 'warning',
                    help: 'Invalid date format.'
                };
            }
        }

        return returnResultObj ? result : result.disabled;
    }

    render() {
        const
        span = 12,
        rowStyle = { textAlign: 'left', marginBottom: '30px' },
        { contact, fsdoInfo } = this.props.fsdo,
        { services } = this.props,
        { date } = this.state;

        return (
            <div style={{ position: 'fixed', textAlign: 'center', top: '34%', width: '100%' }}>
                <Row type='flex' justify='space-around' align='middle' style={rowStyle}>
                    <Col span={span}>
                        <div style={{
                            borderStyle: 'solid',
                            borderWidth: '1px',
                            borderColor: 'rgb(220, 220, 220)',
                            borderRadius: '5px'
                        }}>
                            <Card
                                bodyStyle={{ padding: '0px', textAlign: 'center' }}
                                style={{
                                    borderStyle: 'solid',
                                    borderWidth: '10px',
                                    borderColor: 'rgb(255, 255, 255)',
                                    borderRadius: '5px'
                                }}
                            >
                                <Divider style={{ margin: '0px 0px 8px 0px' }}>
                                    <Icon type='info-circle-o' style={{ fontSize: '20px' }} />
                                </Divider>
                                <div style={{ textAlign: 'left' }}>
                                    <span style={{ fontWeight: 'bold', lineHeight: '16px' }}>{
                                        'Title 18 Section 1001 of the U.S. Code provides that knowingly falsifying or concealing a ' +
                                        'material fact is a felony that may result in fines of up to $10,000 or 5 years in prison or ' +
                                        'both. By submitting this form, you are certifying that the information provided herein is ' +
                                        'true and complete to the best of your knowledge and ability.'
                                    }</span>
                                </div>
                            </Card>
                        </div>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle' style={rowStyle}>
                    <Col span={span}>
                        <Alert
                            type='info'
                            message={(
                                <div>
                                    <Icon type='warning' style={{ color: 'rgb(128, 207, 255)', fontWeight: 'bold', marginRight: '10px' }} />
                                    <span style={{ fontWeight: 'bold', lineHeight: '16px' }}>{
                                        'I hereby declare under penalty of perjury that the information ' +
                                        'contained on this form is true and correct.'
                                    }</span>
                                </div>
                            )}
                        />
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle' style={{...rowStyle, textAlign: 'center', marginBottom: '5px' }}>
                    <Col span={span}>
                        <span style={{ display: 'inline-block', margin: '13px 10px 0px 0px' }}>
                            {'Please enter today\'s date. (Format: MM-DD-YYYY)'}
                        </span>
                        <Form.Item style={{ display: 'inline-block' }} {...this.state.dateFormProps}>
                            <Input
                                size='small'
                                placeholder={'Today\'s date...'}
                                value={this.state.date}
                                style={{ width: '140px' }}
                                onChange={e => this.handleDate(e.target.value, this.isDisabled(e.target.value, true))}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle' style={{}}>
                    <Col span={span}>
                        <Button
                            size='small'
                            style={{ width: '120px', marginRight: '10px', borderRadius: '20px 4px 4px 20px' }}
                            onClick={() => services.changeFsdoValidationStep(1)}
                            disabled={this.isDisabled(date)}
                        >
                            {'I Agree'}
                        </Button>
                        <Link to={ROUTES.ROOT}>
                            <Button
                                size='small'
                                style={{ width: '120px', borderRadius: '4px 20px 20px 4px' }}
                                onClick={() => services.resetFsdoSubmission()}
                            >
                                {'I Disagree'}
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </div>
        );
    }
}
